<template>
  <el-card class="box-card commonTable">
    <el-table :data="tableData"
              style="width: 100%;">
      <el-table-column v-for="(item, index) in commonTableArray"
                       :key="index"
                       :prop="item.props"
                       :label="item.label"
                       :width="isSureWidth ? item.width : ''">
        <template slot-scope="props">
          <b v-if="item.handle"
             @click="$emit('handleItem', props.row)"
             style="cursor: pointer;">{{ props.row[item.props] }}</b>
          <span v-else-if="item.props === 'status' && item.filtersFlag">{{ props.row.status | devicesStatus }}</span>
          <span v-else-if="item.props === 'op_type' && item.filtersFlag">{{ props.row.op_type | opType }}</span>
          <span v-else-if="item.props === 'upgrade_status' && item.filtersFlag">{{ props.row.upgrade_status | upgradeStatus }}</span>
          <span v-else-if="item.img">
            <img :src="props.row[item.props]">
          </span>
          <span v-else>{{ props.row[item.props] }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="isShowOperate"
                       fixed="right"
                       :label="handleName"
                       :width="isOperateWidth"
                       align="center">
        <template slot-scope="{ row }">
          <el-button v-show="isShowEditor"
                     type="text"
                     size="small"
                     @click="editor(row)">
            编辑
          </el-button>
          <el-button v-show="isShowDelete"
                     type="text"
                     size="small"
                     @click="deleteThisRow(row)">
            删除
          </el-button>
          <slot name="operate"
                :row="row"></slot>
        </template>
      </el-table-column>
    </el-table>
    <Pagination ref="pagination"
                v-if="isShowPagination"
                :total="total"
                :current-page="page"
                :page-size="pageSize"
                @changePage="handlePage" />
  </el-card>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import Pagination from '@/components/Pagination/index.vue';

export default {
  components: { Pagination },
  filters: {
    devicesStatus(value) {
      let res;
      if (value === 0) res = '离线';
      if (value === 1) res = '正常';
      if (value === 2) res = '移动';
      if (value === 3) res = '进行中';
      if (value === 4) res = '停用';
      return res;
    },
    opType(val) {
      let res;
      if (val === 1) res = '设计';
      if (val === 2) res = '审核';
      if (val === 3) res = '验收';
      return res;
    },
    upgradeStatus(val) {
      let res;
      if (val === 0) res = '异常';
      if (val === 1) res = '正常';
      return res;
    },
  },
  props: {
    total: {
      type: Number,
      default() {
        return 0;
      },
    },
    commonTableArray: {
      type: Array,
      default() {
        return [];
      },
    },
    isSureWidth: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isOperateWidth: {
      type: Number,
      default() {
        return 120;
      },
    },
    isShowPagination: {
      type: Boolean,
      default() {
        return true;
      },
    },
    isShowOperate: {
      type: Boolean,
      default() {
        return false;
      },
    },
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    deleteData: {
      type: Function,
      default() {
        return null;
      },
    },
    isShowDelete: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isShowEditor: {
      type: Boolean,
      default() {
        return false;
      },
    },
    handleName: {
      type: String,
      default() {
        return '操作';
      },
    },
    page: {
      type: Number,
      default() {
        return 1;
      },
    },
    pageSize: {
      default: 20,
      type: Number,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    editor(item) {
      // this.$refs.pagination.addNewMess(item, true);
      this.$listeners.editorData(item);
    },
    deleteThisRow(item) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$listeners.deleteData(item);
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    handlePage(page) {
      //   this.page = page;
      //   this.handleFetchPlaceList();
      this.$emit('handlePage', page);
    },
  },
};
</script>
<style lang="less" scoped>
// .expandInfoForTransmitLabel {
//   span {
//     margin-left: 15px;
//     font-size: 14px;
//   }
// }
.commonTable {
  &-item {
    cursor: pointer;
  }
}
</style>
